import { withTranslation } from '../../lib/translate';
import { connect } from 'react-redux';
import React from 'react';
import './index.css';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonList, IonPopover, IonToolbar } from '@ionic/react';
import { checkBackgroundColor, forwardTo, getDefaultRoute } from '../../lib/utils';
import { getConfig } from '../../appConfig';
import { chevronDown } from 'ionicons/icons';
import { NormalText, StrongText } from '../common';
import { CLEAR_GIFT_VOUCHER_DATA, SET_COMMON_MODAL } from '../../store/constants';
import { logout, setCommonProp, setDeliveryOption } from '../../store/actions';
import Basket from '../../lib/basket';
import { ReactComponent as AccountsIcon } from '../../assets/images/person.svg';
import Modal from '../modal';
import {OrderSummaryItems} from '../../screens/orderSummary';

class HeaderDesktop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderSummaryModalOpen: false,
            activeDropdown: null,
            logo_image: this.props.clientProfile.logo_image || '',
            logo_image_light:
                this.props.clientProfile.logo_image_light || this.props.clientProfile.logo_image || '',

        };
    }
    
    handleGuestMenuClick = (props, route) => {
        props.dispatch({
            type: SET_COMMON_MODAL,
            modal: 'guestUserRedirectModalOpen',
            value: true,
        });
    };
    setDeliveryOption = (option) => {
        this.props.dispatch(setDeliveryOption(option));
        Basket.setDeliveryOption(option);
        Basket.setOrderType(option.id);
        forwardTo(option.route);
    };
    toggleDropdown = (id, event) => {
        this.setState((prevState) => ({        
            activeDropdown: prevState.activeDropdown === id ? null : id,
        }));
        event.stopPropagation();
    };

    closeDropdown = () => {
        this.setState({ activeDropdown: null });
    };
    componentDidMount() {
        const styles = this.props.clientStyles.colors?.['--okx-header-background'];
        if (styles) {
            this.setState({ backgroundColor: styles });
        }
        const theme = this.props.clientStyles.theme || 'light';
        if (theme) {
            this.setState({ theme });
        }
    }
    handleLogout() {
        this.props.dispatch(logout());
        const defaultRoute = getDefaultRoute(this.props.navConfig);
        forwardTo(defaultRoute.path);
    }
    render() {
        const { auth, __, navConfig, clientProfile } = this.props;
        const { activeDropdown, logo_image, logo_image_light } = this.state;
        const { loggedIn } = auth;
        const defaultRoute = getDefaultRoute(navConfig);

        const sidebarConfig = getConfig().general.sidebarConfig

        const drawerTitle = {
            home: sidebarConfig?.home?.title ?? 'Home',
            order: sidebarConfig?.order?.title ?? 'Order',
            loyalty: sidebarConfig?.loyalty?.title ?? 'Loyalty and reward',
            account: sidebarConfig?.account?.title ?? 'Account',
            about: sidebarConfig?.about?.title ?? 'About us',
            vouchers: sidebarConfig?.vouchers?.title ?? 'eGift Vouchers'

        }
        const groupTitle = [
            (getConfig().flags.hasLoyalty ? { id: 1, title: drawerTitle.loyalty, } : null),
            (getConfig().flags.hasGiftVouchers ? { id: 4, title: drawerTitle.vouchers, } : null),
            { id: 3, title: drawerTitle.about, },
            (loggedIn && { id: 2, title: drawerTitle.account, icon: <AccountsIcon /> }),

        ].filter(Boolean);
        const routes = navConfig.routes.filter((route) => !!route.path && !route.notInDrawer);
        let logoColor = this.state.backgroundColor
            ? checkBackgroundColor(this.state.backgroundColor)
            : 'dark';
        return (
            <>

                <IonHeader className='header-desktop'>
                    <IonToolbar>
                            <div className='pointer' onClick={() => forwardTo(defaultRoute?.path)}>
                                <img style={{height:'40px'}} src={logoColor === 'white' ? logo_image_light : logo_image} />
                            </div>

                        <IonButtons slot="end">
                            {(getConfig().flags.hasOrdering || getConfig().flags.hasBillPay) &&
                                <IonButton id='group_order' onClick={(e) => this.toggleDropdown('order', e)}>
                                    <NormalText className='label-color'>{__('Order')}</NormalText>
                                    <IonIcon icon={chevronDown} />
                                    {getConfig().delivery.filter((d) => !d.isRemoved && !d.isHiddenFromSidebar).length > 0 && (
                                        <IonPopover class='header-popover' showBackdrop={false} trigger={`group_order`} isOpen={activeDropdown === 'order'} >
                                            <IonContent class='navigation-content'>

                                                {getConfig().delivery.map((d, index) => (
                                                    <>
                                                        {!d.isRemoved && !d.isHiddenFromSidebar && (
                                                            <IonItem lines='none'
                                                                onClick={() => {
                                                                    setTimeout(() => {
                                                                        this.setState({ activeDropdown: null }, () => {
                                                                            if (this.props.profile.is_guest) {
                                                                                this.handleGuestMenuClick(this.props, d.route);
                                                                            } else {
                                                                                Basket.getOrderType();
                                                                                this.props.dispatch({
                                                                                    type: CLEAR_GIFT_VOUCHER_DATA,
                                                                                });
                                                                                Basket.reset();
                                                                                this.setDeliveryOption(d);
                                                                            }
                                                                        });
                                                                    }, 0);


                                                                }}
                                                            >
                                                                <NormalText className="label-color">{__(d.label)}</NormalText>
                                                            </IonItem>
                                                        )}
                                                    </>
                                                ))}
                                                {getConfig().flags.hasBillPay && (
                                                    <IonItem lines='none'
                                                        onClick={() => {
                                                            setTimeout(() => {
                                                                this.setState({ activeDropdown: null }, () => {
                                                                    this.props.profile.is_guest ? handleGuestMenuClick(this.props, '/table-bill-pay') : forwardTo('/table-bill-pay');
                                                                });
                                                            }, 0);
                                                        }}
                                                    >
                                                        <NormalText className="label-color">{__('Pay your bill')}</NormalText>
                                                    </IonItem>
                                                )}
                                            </IonContent>
                                        </IonPopover>
                                    )}
                                </IonButton>}
                            {groupTitle.map(group => (
                                <>
                                    <IonButton id={`group_${group.id}`} onClick={(e) => this.toggleDropdown(group.id, e)}>
                                        {group.icon}
                                        <NormalText className='label-color'>{__(group.title)}</NormalText>
                                        <IonIcon icon={chevronDown} />
                                    </IonButton>
                                    <IonPopover class='header-popover' showBackdrop={false} trigger={`group_${group.id}`} isOpen={activeDropdown == group.id} >
                                        <IonContent class='navigation-content'>
                                            {routes.map((route) => (
                                                route.group === group.id && <IonItem lines='none'
                                                    onClick={() => {
                                                        this.setState({ activeDropdown: null }, () => {

                                                            if (this.props.profile.is_guest) {
                                                                this.handleGuestMenuClick(this.props, route.path);
                                                            } else {
                                                                forwardTo(route.path)

                                                            }

                                                        });
                                                    }
                                                    }
                                                >
                                                    <NormalText className="label-color">{__(route.label)}</NormalText></IonItem>
                                            ))}
                                            {(group.id == 2 && loggedIn) &&
                                                <IonItem lines='none' onClick={()=>this.handleLogout()}>
                                                    <NormalText className="label-color">{__('Sign out')}</NormalText></IonItem>
                                            }
                                        </IonContent>
                                    </IonPopover>
                                </>
                            ))}
                            {!loggedIn &&
                                <IonButton onClick={() => forwardTo('/login')}>
                                    <AccountsIcon />
                                    <NormalText className='label-color'>{__('Sign in')}</NormalText>
                                    <IonIcon icon={chevronDown} />

                                </IonButton>

                            }
                            {(Basket.itemsCount() > 0 && !this.props.profile.is_guest && !Basket.is_gift) &&
                                <IonButton onClick={() => {this.props.dispatch(setCommonProp('orderSummaryModalOpen',true));forwardTo('/order')}} fill='solid' color='primary' className='header-basket-btn'>
                                    <NormalText class='header-basket-count'>{Basket.itemsCountAll()}</NormalText>
                                    <StrongText>{__('View order')}</StrongText>
                                    <NormalText>{Basket.calculateItemsTotal()}</NormalText>

                                </IonButton>
                            }
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                {this.props.orderSummaryModalOpen &&
                    <Modal onDidDismiss={() => this.props.dispatch(setCommonProp('orderSummaryModalOpen',false))} className='order-summary-modal' isOpen={this.props.orderSummaryModalOpen}>
                        <OrderSummaryItems />
                        
                    </Modal>
                }
            </>

        );
    }
}

const mapStateToProps = (state) => {
    const { basketUpdated } = state.orders
    const { auth, profile } = state.profile;
    const { appVersion, clientProfile, clientProfileUpdated, navConfig, clientStyles, guestUserRedirectModalOpen,orderSummaryModalOpen } = state.common;
    return {
        auth,
        appVersion,
        profile,
        clientProfile,
        clientProfileUpdated,
        navConfig,
        clientStyles,
        guestUserRedirectModalOpen,
        basketUpdated,
        orderSummaryModalOpen

    };
};

export default connect(mapStateToProps)(withTranslation(HeaderDesktop));
